<template>
  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <path
      d="M4 11C4 8.79 5.79 7 8 7H16C18.21 7 20 8.79 20 11V19C20 21.21 18.21 23 16 23H8C5.79 23 4 21.21 4 19V15"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.2"
    />
    <path
      d="M8 6C8 3.79 9.79 2 12 2C14.21 2 16 3.79 16 6"
      stroke="currentColor"
      stroke-linecap="round"
      stroke-width="1.2"
    />
  </svg>
</template>
